import { Component } from 'react';
import Truncate from 'react-truncate';
import { Button } from 'react-bootstrap';
import { history } from '../../../../store';

import './brand-carousel.css';
import './style.css';

class BrandBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth
    };
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { links, attributes } = this.props;
    const isMobileScreen = this.state.windowWidth <= 480;
    const bannerContent = (
      attributes['banner-title'] !== '' || attributes['banner-text'] !== '' || attributes['banner-button-text'] !== ''
    ) && (
      attributes['banner-title'] !== null || attributes['banner-text'] !== null || attributes['banner-button-text'] !== null
    );

    return (
      <div className="brand-carousel-banner-container">
        <img src={links.banner} alt={attributes.name} className="brand-carousel-banner-image" />
        <div className="brand-carousel-content-container">
          {
            (bannerContent || !isMobileScreen) && (
              <div className="brand-carousel-text-container">
                {attributes['banner-title'] && (
                  <h3
                    id="brand-carousel-title"
                    style={{
                      color: attributes['banner-text-colour']
                    }}
                  >
                    {attributes['banner-title'] || ''}
                  </h3>
                )}
                <p
                  id="brand-carousel-subtitle"
                  style={{
                    color: attributes['banner-text-colour']
                  }}
                >
                  {attributes['banner-text'] || ''}
                </p>
                {attributes['banner-button-text'] && (
                  <Button
                    id="brand-carousel-button"
                    className='red-btn'
                    onClick={() => {
                      if (attributes['banner-button-url'].match(/^https?:.*/i)) {
                        window.open(attributes['banner-button-url'], '_blank');
                      } else {
                        history.push(attributes['banner-button-url']);
                      }
                    }}
                  >
                    {attributes['banner-button-text']}
                  </Button>
                )}
              </div>
            )
          }
          <div
            className={`disclaimer-text-container
            ${!attributes['banner-title'] && !attributes['banner-text'] && !attributes['banner-button-text'] ? 'centered-disclaimer' : ''}`}
            style={{
              color: attributes['banner-text-colour']
            }}
          >
            <Truncate lines={3} ellipsis={<span>...</span>}>
              {attributes['disclaimer-text']}
            </Truncate>
          </div>
        </div>
      </div>
    );
  }
}

export default BrandBanner;
